import useRequest from '@/websdk/utils/request';
export default (function () {
  const { isRequestSuccessed, data, isLoading, exec } = useRequest({
    url: '/api/order/count12',
    name: 'productionMonthCountGet',
    method: 'GET'
  });
  return [isRequestSuccessed, data || [], exec, isLoading];
});
